<div class="body">
  <div class="container">
    <div class="row title-box mt-3">
      <div class="col-12 col-sm-12">
        <h3 class="txtbienvenida">Cambiar <span class="txtbienvenida-2">contraseña</span></h3>
      </div>
    </div>
    <form class="custom-form" [formGroup]="cambioContraForm">
      <div class="row justify-content-md-start">
        <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xs-6 mt-4">
          <div class="mb-3 required form-label" [ngClass]="{'is-invalid':validateField('contraActual')}">
            <label for="passwordActual" class="form-label">Contraseña actual</label>
            <div class="input-group">
              <input maxlength="20" [type]="isVisible ? 'text' : 'password'" class="form-control" formControlName="contraActual" [ngClass]="{'is-invalid':validateField('contraActual')}" required />
              <span class="input-group-text" (click)="showPassword()">
                <span [class]="isVisible ? 'fas fa-eye-slash' : 'fas fa-eye'"></span>
              </span>
              <div class="invalid-feedback">
                Campo obligatorio (Debe tener como mínimo 8 caracteres, 1 mayúscula, 1 minúscula, 1 número y 1 caracter especial (&#64;$+#!%*?&-/_.,))
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row justify-content-md-center">
        <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xs-6 mt-4">
          <div class="mb-3 required form-label" [ngClass]="{'is-invalid':validateField('contraNueva')}">
            <label for="passwordNew" class="form-label">Contraseña nueva</label>
            <div class="input-group">
              <input maxlength="20" [type]="isVisibleNueva ? 'text' : 'password'" class="form-control" formControlName="contraNueva" [ngClass]="{'is-invalid':validateField('contraNueva')}" required />
              <span class="input-group-text" (click)="showPasswordNueva()">
                <span [class]="isVisibleNueva ? 'fas fa-eye-slash' : 'fas fa-eye'"></span>
              </span>
              @if (!cambioContraForm.controls.contraNueva.hasError('repeatPass')) {
                <div class="invalid-feedback">
                  Campo obligatorio (Debe tener como mínimo 8 caracteres, 1 mayúscula, 1 minúscula, 1 número y 1 caracter especial (&#64;$+#!%*?&-/_.,))
                </div>
              }
            </div>
            @if (cambioContraForm.controls.contraNueva.hasError('repeatPass')) {
              <div class="form-text">
                La contraseña nueva debe ser diferente a la actual
              </div>
            }
          </div>
        </div>
        <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xs-6 mt-4">
          <div class="mb-3 form-label">
            <label for="confirmPassword" class="form-label">Confirme contraseña nueva*</label>
            <div class="input-group">
              <input maxlength="20" [type]="isConfirm ? 'text' : 'password'" class="form-control" formControlName="confirContraNueva" />
              <span class="input-group-text" (click)="showConfirmPassword()">
                <span [class]="isConfirm ? 'fas fa-eye-slash' : 'fas fa-eye'"></span>
              </span>
            </div>
            @if (cambioContraForm.controls.confirContraNueva.hasError('confirmPasswordMatch')) {
              <div class="form-text">
                Las contraseñas no coinciden
              </div>
            }
          </div>
        </div>
      </div>
      <div class="row justify-content-md-center g-3">
        <div class="col-12 col-md-2 container-btn">
          <button id="btn-cambiar-contrasena-if-guardar" [disabled]="!cambioContraForm.valid" class="btn btn-primary hvr-shrink" (click)="guardarContraNueva()" style="width: 180px;" type="submit">
            @if (isLoading) {
              <div class="spinner-grow text-light" role="status">
                <span class="sr-only">Loading...</span>
              </div>
            }
            {{ isLoading ? "" : "Guardar" }}
          </button>
        </div>
        <div class="col-12 col-md-2 container-btn">
          <button id="btn-cambiar-contrasena-if-volver" class="btn  btn-primary hvr-shrink" style="width: 180px;" routerLink="/intermediario/home" (click)="trackVolver()">Volver</button>
        </div>
      </div>
    </form>
  </div>
  <!-- Modal -->
  <div class="modal fade text-center" style="color: black;" id="mensajeModal" tabindex="-1" aria-labelledby="mensajeModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-body justify-content-md-center">
          <div class="row">
            <div class="col-12 col-sm-12 me-3 ms-3">
              <h2>La contraseña ha sido actualizada exitosamente</h2>
            </div>
          </div>
        </div>
        <div class="modal-footer justify-content-md-center">
          <button type="button" class="btn btn-primary" data-bs-dismiss="modal" routerLink="/intermediario/home">Aceptar</button>
        </div>
      </div>
    </div>
  </div>
  <div class="footer-body"></div>
</div>